import { DimensionedNumberDisplay } from "common/components/DimensionedNumberDisplay";
import { Paper, Typography } from "@mui/material";
import React from "react";

interface DimensionedNumberDisplayModuleProps
  extends React.ComponentProps<typeof DimensionedNumberDisplay> {
  title: string;
}

export const DimensionedNumberDisplayModule: React.FC<
  DimensionedNumberDisplayModuleProps
> = ({ title, ...dimensionedNumberDisplayProps }) => {
  return (
    <Paper className="p-4 rounded-lg">
      <Typography variant="body1">{title}</Typography>
      <Typography variant="h6">
        <DimensionedNumberDisplay {...dimensionedNumberDisplayProps} />
      </Typography>
    </Paper>
  );
};
